
import BoxCheckbox from "@/components/base/input/BoxCheckbox"

export default {
    name: "BoxCheckboxFilter",
    components: { BoxCheckbox },
}
